import { render, staticRenderFns } from "./EventsForm.vue?vue&type=template&id=c0898202"
import script from "./EventsForm.vue?vue&type=script&lang=js"
export * from "./EventsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports